module.exports = __webpack_public_path__ + "img/service-options-swoop-black.efe827f4.jpg";